<div class="modal-header has-close">
  <div class="modal-title" ngbAutofocus>
    <span>Forgot password</span>
  </div>
  <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="handleCloseModal()"
    >
      <img src="assets/icons/ic-close@3x.svg" alt="" />
    </button>
  
</div>
<div class="header-message">
  Please fill in the following to reset your password tagged to this Case ID. 
</div>
<div class="modal-body">
  <div class="row">
    
    <div class="col-lg-6">
      <div class="password-form-wrapper">
        <form id="form-login" [formGroup]="forgotPasswordForm">
          <div class="field-wrapper">
            <label>
              <span>Case ID</span>
              <input
                [class.invalid-input]="
                 false
                "
               
                formControlName="caseID"
                required
              />
            </label>
            <!--      Value: {{ emailAddress.value }}-->
            <!--      Error: {{ emailAddress.errors | json }}-->
            <!--      Dirty: {{ emailAddress.dirty | json }}-->
            
          </div>

          
          <div class="field-wrapper">
            <label>
              <span>Email Address</span>
              <input
                [class.invalid-input]="
                  false
                "
              
                formControlName="emailID"
                required
              />
            </label>
            
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <app-primary-button
    (click)="onForgotPassword()"
    [disabled]="
    !forgotPasswordForm.valid
    "
    >OK
  </app-primary-button>
</div>
